import styled from "@emotion/styled";

import { Select } from "shared/components/Form";

export const FullWidthSelect = styled(Select)`
  width: 100%;
  min-width: 300px;
`;
